import styled from 'styled-components';

export const StyledSecondStep = styled.div`
  .body {
    margin: 32px 72px 0 72px;
  }

  .first-step-icon {
    padding: 10px;
    background-color: #DDF9E4;
    border-radius: 3px;
  }

  .main-container {
    border: 1px solid rgba(81, 37, 143, 0.5);
    border-radius: 8px;

    p {
      background: rgba(81, 37, 143, 0.2);
      border-radius-top-left: 8px;
      border-radius-top-right: 8px;
      padding: 4px 0 4px 16px;
    }

    .ant-form-item {
      justify-content: center;
    }
  }

  .admission {
    &__error {
      margin-bottom: 24px;
      padding: 0;
      border-radius: 12px 5px 5px 12px !important;


      .ant-alert-message {
        padding: 4px 24px;
      }

      .ant-alert-icon {
        padding: 14px;
        background: #F7B422 !important;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }
    }
  }

  .ant {
    &-table {

      &-thead {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &-tbody {
        .ant-btn {
          top: 0;

          border: none;
          box-shadow: none;
        }
      }
    }

    &-btn {
      svg {
        position: relative;
        bottom: 2px;
      }
    }
  }
`